/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, ChangeEvent, useRef, useCallback, useMemo } from "react";
import { Block, Check, GroupAdd, PersonAdd } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';

import {
  Tab, Tabs, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, IconButton, TableContainer, Table, TableHead,
  TableBody, TableRow, TableCell, TablePagination, Drawer, MenuItem,
  Paper, Tooltip,
  Snackbar,
  Grid,
  useMediaQuery,
  InputAdornment
} from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { appStore } from "src/framework/store/AppStore";
import { Alert } from '@mui/material';
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import theme from "src/theme/light";
import { CardColaboradorMobile } from "./CardColaboradorMobile";
import "./styles.css";
import { Empty } from "./Empty";

export interface Colaborador {
  id: number;
  usuario: string;
  nome: string;
  grupo_acesso: GrupoAcesso | null;
  created_at: string;
}
interface GrupoAcesso {
  id: number;
  nome: string;
  descricao: string | null;
}
interface ColaboradoresResponse {
  rows: Colaborador[];
  infoRows: {
    count: number;
    page: number;
    pageCount: number;
  };
}

function Colaboradores() {
  const permissoes = PermissionUtil.getPermissions();

  const [orderByAtivo, setorderByAtivo] = useState('nome');
  const [grupoAcessoLoaded, setGrupoAcessoLoaded] = useState(false);
  const [orderByInativo, setorderByInativo] = useState('nome');
  const [cadastroSortIndicatorAtivo, setCadastroSortIndicatorAtivo] = useState('▲');
  const [cadastroSortIndicatorInativo, setCadastroSortIndicatorInativo] = useState('▲');
  const [nomeSortIndicatorAtivo, setNomeSortIndicatorAtivo] = useState('▲');
  const [nomeSortIndicatorInativo, setNomeSortIndicatorInativo] = useState('▲');
  const [selectedGrupoAcesso, setSelectedGrupoAcesso] = useState<GrupoAcesso | null | undefined>(null);
  const [activeTab, setActiveTab] = useState('ativos');
  const [openDialog, setOpenDialog] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [openNewUserDialog, setOpenNewUserDialog] = useState(false);
  const [pageAtivos, setPageAtivos] = useState(0);
  const [pageInativos, setPageInativos] = useState(0);
  const [editSnackbarOpen, setEditSnackbarOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [activateDialogOpen, setActivateDialogOpen] = useState(false);
  const [selectedFuncao, setSelectedFuncao] = useState('');
  const [colaboradorId, setColaboradorId] = useState('');
  const [colaboradorUser, setColaboradorUser] = useState('');
  const [colaboradorName, setColaboradorName] = useState('');
  const firstRender = useRef(true);
  const [should, setShould] = useState(true);
  const [colaboradores, setColaboradores] = useState<Colaborador[]>([]);
  const [totalPagesActive, setTotalPagesActive] = useState(0);
  const [totalPagesInactive, setTotalPagesInactive] = useState(0);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [colaboradoresInativos, setColaboradoresInativos] = useState<Colaborador[]>([]);
  const [emailError, setEmailError] = useState('');
  const [gruposAcesso, setGruposAcesso] = useState<GrupoAcesso[]>([]);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const Colaboradores = useCallback(async () => {
    const request: IDataRequest = {
      url: `/contas/usuarios?page=${pageAtivos + 1}&limit=${rowsPerPage}&ativo=true&orderby=${orderByAtivo}`,
    };

    apiNoLoading.get(request)
      .then((response: IDataResponse<ColaboradoresResponse>) => {
          setColaboradores(response?.data?.rows || []);
          setTotalPagesActive(response?.data?.infoRows?.count || 0);
      })
      .catch((error) => {
        appStore.setError(['Ocorreu um erro ao inserir colaboradores.']);
      });
  }, [pageAtivos, rowsPerPage, orderByAtivo]);

  const ColaboradoresInativos = useCallback(async () => {
    const request: IDataRequest = {
      url: `/contas/usuarios?page=${pageInativos + 1}&limit=${rowsPerPage}&ativo=false&orderby=${orderByInativo}`,
    };

    try {
      const response: IDataResponse<ColaboradoresResponse> = await apiNoLoading.get(request);
        setColaboradoresInativos(response.data?.rows || []);
        setTotalPagesInactive(response.data?.infoRows?.count || 0);
    } catch (error) {
      console.error('Erro ao buscar colaboradores inativos:', error);
      appStore.setError(['Ocorreu um erro ao buscar colaboradores inativos.']);
    }
  }, [pageInativos, rowsPerPage, orderByInativo]);

  const GruposAcesso = useCallback(async () => {
    const request: IDataRequest = {
      url: '/contas/grupos',
    };

    try {
      const response: IDataResponse<GrupoAcesso[]> = await apiNoLoading.get(request);
      if (response.statusCode === STATUS_CODE.OK) {
        setGruposAcesso(response.data);
      }
    } catch (error) {
      console.error('Ocorreu um erro ao buscar os grupos de acesso:', error);
      appStore.setError(['Ocorreu um erro ao buscar os grupos de acesso.']);
    }
  }, []);

  const handleChange = (event: ChangeEvent<{}>, newValue: string) => {
    setActiveTab(newValue);
    if (searchText) setSearchText("");
  };

  const handleSearchClick = () => {
    setOpenDialog(true);
    setPageAtivos(0);
    setPageInativos(0);
  };
  
  const handleSnackbarClose = (event?:  Event | React.SyntheticEvent, reason?: string) => {
    setOpenSnackbar(false);
  };

  const handleCadastroSortClickAtivo = () => {
    if (orderByAtivo === 'created_at') {
      setorderByAtivo('created_at-desc');
      setCadastroSortIndicatorAtivo('▼');
    } else {
      setorderByAtivo('created_at');
      setCadastroSortIndicatorAtivo('▲');
    }
    setShould(true);
  };

  const handleCadastroSortClickInativo = () => {
    if (orderByInativo === 'created_at') {
      setorderByInativo('created_at-desc');
      setCadastroSortIndicatorInativo('▼');
    } else {
      setorderByInativo('created_at');
      setCadastroSortIndicatorInativo('▲');
    }
    setShould(true);
  };

  const handleNomeSortClickAtivo = () => {
    if (orderByAtivo === 'nome') {
      setorderByAtivo('nome-desc');
      setNomeSortIndicatorAtivo('▼');
    } else {
      setorderByAtivo('nome');
      setNomeSortIndicatorAtivo('▲');
    }
    setShould(true);
  };

  const handleNomeSortClickInativo = () => {
    if (orderByInativo === 'nome') {
      setorderByInativo('nome-desc');
      setNomeSortIndicatorInativo('▼');
    } else {
      setorderByInativo('nome');
      setNomeSortIndicatorInativo('▲');
    }
    setShould(true);
  };

  const handleCloseDialog = useCallback(async () => {
    setOpenDialog(false);

    let page = 0;
    let activeTabParam: 'true' | 'false' = 'true';

    if (activeTab === 'ativos') {
      page = pageAtivos;
      activeTabParam = 'true';
    } else {
      page = pageInativos;
      activeTabParam = 'false';
    }

    if (searchText.trim() === '') {
      if (activeTab === 'ativos') {
        Colaboradores();
      } else {
        ColaboradoresInativos();
      }
      return;
    }

    const request: IDataRequest = {
      url: `/contas/usuarios?page=${page + 1}&limit=${rowsPerPage}&ativo=${activeTabParam}&nome_like=${searchText}`,
    };

    try {
      const response: IDataResponse = await apiNoLoading.get(request);

      if (activeTab === 'ativos') {
        setColaboradores(response.data?.rows || []);
        setTotalPagesActive(response.data?.infoRows?.count || 0);
      } else {
        setColaboradoresInativos(response.data?.rows || []);
        setTotalPagesInactive(response.data?.infoRows?.count || 0);
      }
    } catch (error) {
      console.error('Erro na solicitação:', error);
    }
  }, [activeTab, searchText, rowsPerPage, pageAtivos, pageInativos, Colaboradores, ColaboradoresInativos]);

  const canCreateColaborador = useMemo(() => {
    return PermissionUtil.can(PermissionUtil.PERMISSION_CRIAR_COLABORADOR, permissoes)
  }, [permissoes])

  const canEditColaborador = useMemo(() => {
    return PermissionUtil.can(PermissionUtil.PERMISSION_ATUALIZAR_COLABORADOR, permissoes)
  }, [permissoes])

  const canAtivarInativarColaborador = useMemo(() => {
    return PermissionUtil.can(PermissionUtil.PERMISSION_INATIVAR_COLABORADOR, permissoes)
  }, [permissoes])

  const handleClearSearch = () => {
    setSearchText('');
    setPageAtivos(0);
    setPageInativos(0);
  };

  const handleNewUserClick = () => {
    setOpenNewUserDialog(true);
    setSelectedFuncao('');
  };

  const handleCloseNewUserDialog = () => {
    setOpenNewUserDialog(false);
    setEmailError('');
    setGrupoAcessoLoaded(false);
  };

  const handleConfirmNewUserSave = async () => {
    const nomeInput = document.getElementById('nome-input') as HTMLInputElement | null;
    const funcaoSelect = document.getElementById('funcao-select') as HTMLSelectElement | null;
    const emailInput = document.getElementById('email-input') as HTMLInputElement | null;

    if (!nomeInput || !funcaoSelect || !emailInput) {
      console.error('Não foi possível encontrar os campos do formulário.');
      return;
    }
    if (!emailInput) {
      console.error('Não foi possível encontrar o campo de email.');
      return;
    }
    const emailValue = emailInput.value;

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailValue || !emailRegex.test(emailValue)) {
      setEmailError('Informe um e-mail válido');
      return; // Prevent submission if email is invalid
    }

    const newColaborador = {
      nome: nomeInput.value,
      usuario: emailInput.value,
      grupos_acesso: [{ grupo_acesso_id: parseInt(selectedFuncao, 10) }]
    };

    const request: IDataRequest = {
      url: '/contas/usuarios/',
      data: newColaborador
    };

    try {
      const response: IDataResponse<any> = await apiNoLoading.post(request);

      if (response.statusCode === STATUS_CODE.CREATED) {
        Colaboradores();
        handleCloseNewUserDialog();
        setOpenSnackbar(true); // Show Snackbar
      } else {
        console.error('Erro ao criar colaborador:', response.statusCode);
      }
    } catch (error) {
      console.error('Erro na solicitação:', error);
    }
  };

  const handleEditClick = (colaborador: Colaborador) => {
    setEditDialogOpen(true);
    setColaboradorId(String(colaborador.id));
    setColaboradorUser(String(colaborador.usuario));
    setColaboradorName(String(colaborador.nome));
    setSelectedFuncao(String(colaborador.grupo_acesso?.id || ''));

    const grupoAcesso = gruposAcesso.find(ga => ga.id === colaborador.grupo_acesso?.id);
    setSelectedGrupoAcesso(grupoAcesso || null);
  };

  const handleDeleteClick = () => {
    setDeleteDialogOpen(true);
  };

  const handleActivateClick = () => {
    setActivateDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setEmailError('');
    setGrupoAcessoLoaded(false);
  };

  const handleEditSnackbarClose = (event?: Event | React.SyntheticEvent, reason?: string) => {
    setEditSnackbarOpen(false);
  };

  const handleCloseEditDialogSave = async () => {
    const nomeInput = document.getElementById('nome-edit-input') as HTMLInputElement | null;
    const emailInput = document.getElementById('email-edit-input') as HTMLInputElement | null;

    if (!nomeInput || !selectedFuncao || !emailInput) {
      console.error('Não foi possível encontrar os campos do formulário.');
      return;
    }
    if (!emailInput) {
      console.error('Não foi possível encontrar o campo de email.');
      return;
    }
    const emailValue = emailInput.value;

    // Email validation regex 
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailValue || !emailRegex.test(emailValue)) {
      setEmailError('Informe um e-mail válido');
      return; // Prevent submission if email is invalid
    }

    setEditDialogOpen(false);

    const editColaborador = {
      nome: nomeInput.value,
      usuario: emailInput.value,
      grupos_acesso: [{ grupo_acesso_id: parseInt(selectedFuncao, 10) }]
    };

    const request: IDataRequest = {
      url: `/contas/usuarios/${colaboradorId}`,
      data: editColaborador
    };

    try {
      const response: IDataResponse = await apiNoLoading.put(request);
      if (response.statusCode === STATUS_CODE.OK) {
        Colaboradores();
        handleCloseEditDialog();
        setEditSnackbarOpen(true);
      } else {
        console.error('Erro ao editar colaborador:', response.message);
      }
    } catch (error) {
      console.error('Erro na solicitação:', error);
    }
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  const handleCloseDeleteDialogYes = async () => {
    setDeleteDialogOpen(false);

    const ativoNaoAtivo = {
      ativo: false
    };

    const request: IDataRequest = {
      url: `/contas/usuarios/${colaboradorId}/ativo`,
      data: ativoNaoAtivo
    };
    try {
      const response: IDataResponse = await apiNoLoading.patch(request);
      if (response.statusCode === STATUS_CODE.OK) {

        setColaboradores(prevColaboradores => prevColaboradores.filter(colaborador => colaborador.id !== parseInt(colaboradorId)));

        if (colaboradores.length === 0) {
          setTotalPagesActive(prevTotalPages => Math.max(prevTotalPages - 1, 0));
        }

      } else {
        console.error('Erro ao editar colaborador:', response.message);
      }
    } catch (error) {
      console.error('Erro na solicitação:', error);
    }
  };
  const handleCloseDeleteDialogNo = () => {
    setDeleteDialogOpen(false);
  };
  const handleCloseActivateDialog = async () => {
    setActivateDialogOpen(false);
  };
  const handleCloseActivateDialogYes = async () => {
    setActivateDialogOpen(false);

    const NaoAtivoAtivo = {
      ativo: true
    };

    const request: IDataRequest = {
      url: `/contas/usuarios/${colaboradorId}/ativo`,
      data: NaoAtivoAtivo
    };

    try {
      const response: IDataResponse = await apiNoLoading.patch(request);
      if (response.statusCode === STATUS_CODE.OK) {
        // Remove o colaborador da lista de colaboradores inativos
        setColaboradoresInativos(prevColaboradores => prevColaboradores.filter(colaborador => colaborador.id !== parseInt(colaboradorId)));

        // Atualiza a lista de colaboradores inativos
      } else {
        console.error('Erro ao editar colaborador:', response.message);
      }
    } catch (error) {
      console.error('Erro na solicitação:', error);
    }
  };
  const handleCloseActivateDialogNo = async () => {
    setActivateDialogOpen(false);
  };

  useEffect(() => {
    if (firstRender.current || should) {
      if (searchText.trim() !== '' && (pageAtivos > 0 || pageInativos > 0)) {

        handleCloseDialog();
      } else {

        if (activeTab === 'ativos') {
          Colaboradores();
        } else if (activeTab === 'inativos') {
          ColaboradoresInativos();
        }
        GruposAcesso();
      }
      setShould(false);
      firstRender.current = false;
    }
  }, [Colaboradores, ColaboradoresInativos, GruposAcesso, should, searchText, activeTab]);

  useEffect(() => {
    setShould(true);
  }, [pageAtivos, pageInativos, rowsPerPage, activeTab]);

  const rowsAcessos = gruposAcesso.map((grupoAcesso: any) => ({
    id: grupoAcesso.id,
    usuario: grupoAcesso.nome,
    cadastro: grupoAcesso.descricao,
  }));

  useEffect(() => {
    const handler = setTimeout(() => {
      if (isMobile) handleCloseDialog();
    }, 300);

    return () => clearTimeout(handler);
  }, [searchText, isMobile, handleCloseDialog]);

  const inputBuscaColaborador = useMemo(() => {
    return (
      <TextField
        fullWidth
        style={{ marginTop: 20 }}
        label="Busca por nome"
        variant="outlined"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="action" style={{ fontSize: 33, marginTop: 3 }} />
            </InputAdornment>
          ),
        }}
      />
    )
  }, [searchText])

  return (
    <Paper elevation={0} className="colaboradores-root">
      <Snackbar
        open={editSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleEditSnackbarClose}
        className="fixed-snackbar"
        style={{
          position: 'relative',
          width: '100%',
          top: '20px',
        }}
      >
        <Alert onClose={handleEditSnackbarClose} severity="success">
          Colaborador editado com sucesso!
        </Alert>
      </Snackbar>

      <Box sx={{ width: '100%' }}>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          className="fixed-snackbar"
          style={{
            position: 'relative',
            width: '100%',
            top: '20px',
          }}
        >
          <Alert onClose={handleSnackbarClose} severity="success"> E-mail enviado para que o colaborador prossiga com o cadastro
          </Alert>
        </Snackbar>

        <Tabs
          value={activeTab}
          onChange={handleChange}
          textColor="secondary"
          aria-label="secondary tabs example"
        >
          <Tab value="ativos" label="Ativos" />
          <Tab value="inativos" label="Inativos" />
        </Tabs>

        {!isMobile && (
          <div style={{ float: 'right', marginTop: '15px' }}>
            <Box display="inline" sx={{ textAlign: 'right', }}>
              <Tooltip title='Filtros'>
                <IconButton onClick={handleSearchClick}>
                  <Search fontSize="medium" />
                </IconButton>
              </Tooltip>
            </Box>
          </div>
        )}

        <Drawer PaperProps={{ style: { width: 400 } }} anchor="right" open={openDialog} onClose={handleCloseDialog}>
          <Box paddingLeft={'10px'} >
            <Button
              variant="text"
              color="primary"
              startIcon={<Close />}
              style={{ marginTop: 10, marginBottom: 50 }}
              onClick={handleCloseDialog}
            >
              Fechar
            </Button>
          </Box>
          <Box flex={1} padding={2} alignItems='flex-start' display='flex' flexDirection={'column'}>
            <TextField
              fullWidth
              style={{ marginTop: 20 }}
              label="Busca por nome"
              variant="outlined"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            /></Box>
          <Box height='75px' p={2} marginTop={'10px'} width={'100%'} display='flex' justifyContent={'flex-end'}>
            <Button onClick={handleClearSearch} style={{ marginRight: '10px' }} color="primary" variant="outlined">Limpar filtros</Button>
            <Button onClick={handleCloseDialog} color="primary" variant="contained">Buscar</Button>
          </Box>
        </Drawer>

        {activeTab === 'ativos' && (
          <>
            <div style={isMobile ? { margin: "25px 0px" } : { float: 'left', margin: '15px 0px' }}>
              <Box display="inline">
                {canCreateColaborador && <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNewUserClick}
                  fullWidth={isMobile}
                >
                  NOVO COLABORADOR
                </Button>}
              </Box>
            </div>
            
            { isMobile && inputBuscaColaborador }

            {/* Novo usuário dialog */}
            <Dialog open={openNewUserDialog} onClose={handleCloseNewUserDialog} fullWidth maxWidth="md" className="modal-colaborador">
              <DialogContent style={{ overflowY: 'initial' }}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <DialogTitle style={isMobile ? { color: '#00AF39', fontWeight: 'bold', padding: "10px 0px" } : { color: '#00AF39', fontWeight: 'bold' }}>
                      <Box display="flex" alignItems="center" style={isMobile ? { marginBottom: 10 } : {}}>
                        <PersonAdd />
                        &nbsp;Novo colaborador
                      </Box>
                    </DialogTitle>

                    {/* Campos do novo usuário */}
                    <TextField id="nome-input" label="Nome" variant="outlined" fullWidth />
                    <TextField
                      id="funcao-select"
                      style={{ marginTop: '20px' }}
                      select
                      label="Função"
                      variant="outlined"
                      fullWidth
                      value={selectedFuncao}
                      onChange={(e) => {
                        setSelectedFuncao(e.target.value);
                        const selectedGrupo = gruposAcesso.find(grupo => grupo.id === parseInt(e.target.value, 10));
                        setSelectedGrupoAcesso(selectedGrupo); // Atualiza o estado do grupo de acesso selecionado
                        setGrupoAcessoLoaded(true);
                      }}
                    >
                      {rowsAcessos.map((grupoAcesso) => (
                        <MenuItem key={grupoAcesso.id} value={grupoAcesso.id}>
                          {grupoAcesso.usuario}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      id="email-input"
                      style={{ marginTop: '20px' }}
                      label="Email"
                      variant="outlined"
                      fullWidth
                      error={!!emailError}
                      helperText={emailError}
                    />
                  </Grid>
                  {/* Container do lado direito com overflow hidden */}
                  <Grid size={{ xs: 12, md: 6 }}>
                    {!selectedGrupoAcesso?.descricao ? (
                      <>
                        {grupoAcessoLoaded && ( // Remove the extra '?'
                          <DialogTitle style={{ color: '#00AF39', fontWeight: 'bold' }}>
                            <Box display="flex" alignItems="center">
                              {!selectedGrupoAcesso?.descricao && (
                                <>
                                  <GroupAdd />  Função {selectedGrupoAcesso?.nome}
                                </>
                              )}
                            </Box>
                          </DialogTitle>
                        )}

                        {!isMobile && (
                          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            {!grupoAcessoLoaded ? (
                              <>
                                <img src="/imagem-novo-colaborador.jpg" alt="Imagem Novo Colaborador" style={{ maxWidth: '100%', maxHeight: '255px', marginTop: '60px' }} />
                              </>
                            ) : (
                              <>
                                <img src="/imagem-novo-colaborador.jpg" alt="Imagem Novo Colaborador" style={{ maxWidth: '100%', maxHeight: '255px' }} />
                              </>
                            )}
                          </Box>
                        )}
                      </>
                    ) : (
                      selectedGrupoAcesso && selectedGrupoAcesso.descricao ? (
                        <>
                          <DialogTitle style={{ color: '#00AF39', fontWeight: 'bold' }}><Box display="flex" alignItems="center"><GroupAdd />&nbsp;Função {selectedGrupoAcesso.nome}</Box></DialogTitle>
                          {selectedGrupoAcesso.descricao.includes('\n') ? (
                            <div> {/* Usa div em vez de ul */}
                              {selectedGrupoAcesso.descricao.split('\n').map((item, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                  <CheckCircleIcon style={{ color: '#00a335' }} /> {item}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <CheckCircleIcon style={{ color: '#00a335' }} /> &nbsp; {selectedGrupoAcesso.descricao}
                            </div>
                          )}
                        </>
                      ) : null
                    )}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions style={isMobile ? { display: 'block', padding: "0px 20px 20px 20px"} : { justifyContent: 'flex-start', marginLeft: '220px', paddingBottom: '20px' }}>
                <Button variant="outlined" onClick={handleCloseNewUserDialog} color={isMobile ? "secondary" : "primary"} fullWidth={isMobile}>
                  Cancelar
                </Button>
                <Button variant="contained" onClick={handleConfirmNewUserSave} color="primary" fullWidth={isMobile} className="btn-confirmar">
                  Confirmar
                </Button>
              </DialogActions>
            </Dialog>

            {/* Editar colaborador dialog */}
            <Dialog open={editDialogOpen} onClose={handleCloseEditDialog} fullWidth maxWidth="md" className="modal-colaborador">
              <DialogContent style={{ overflowY: 'initial' }}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <DialogTitle style={isMobile ? { color: '#00AF39', fontWeight: 'bold', padding: "10px 0px" } : { color: '#00AF39', fontWeight: 'bold' }}>
                      <Box display="flex" alignItems="center" style={isMobile ? { marginBottom: 15 } : {}}>
                        <PersonAdd /> 
                        &nbsp; Editando colaborador
                      </Box>
                    </DialogTitle>
                    {/* Campos para editar usuário */}
                    <TextField
                      id="nome-edit-input"
                      value={colaboradorName}
                      label="Nome"
                      variant="outlined"
                      fullWidth
                      onChange={(e) => setColaboradorName(e.target.value)}
                    />

                    <TextField
                      id="funcao-select-edit"
                      style={{ marginTop: '20px' }}
                      select
                      label="Função"
                      variant="outlined"
                      fullWidth
                      //value={colaboradorGrupoAcessoId}
                      //onChange={handleGrupoAcessoChange}
                      value={selectedFuncao}
                      onChange={(e) => {
                        setSelectedFuncao(e.target.value);
                        const selectedGrupo = gruposAcesso.find(grupo => grupo.id === parseInt(e.target.value, 10));
                        setSelectedGrupoAcesso(selectedGrupo); // Atualiza o estado do grupo de acesso selecionado
                      }}
                    >
                      {rowsAcessos.map((grupoAcesso) => (
                        <MenuItem key={grupoAcesso.id} value={grupoAcesso.id}>
                          {grupoAcesso.usuario}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      id="email-edit-input"
                      value={colaboradorUser}
                      style={{ marginTop: '20px' }}
                      label="Email"
                      variant="outlined"
                      fullWidth
                      disabled
                      onChange={(e) => setColaboradorUser(e.target.value)}
                      error={!!emailError} // Show error if emailError is not empty
                      helperText={emailError} // Display error message
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    {!selectedGrupoAcesso?.descricao ? (
                      <>
                        <DialogTitle style={{ color: '#00AF39', fontWeight: 'bold' }}>
                          <Box display="flex" alignItems="center"> {!selectedGrupoAcesso?.descricao && (
                            <>
                              <GroupAdd /> &nbsp;Função {selectedGrupoAcesso?.nome}
                            </>)}
                          </Box>
                        </DialogTitle>
                        {!isMobile && (
                          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <img src="/imagem-novo-colaborador.jpg" alt="Imagem Novo Colaborador" style={{ maxWidth: '100%', maxHeight: '255px' }} />
                          </Box>
                        )}
                      </>
                    ) : (
                      selectedGrupoAcesso && selectedGrupoAcesso.descricao ? (
                        <>
                          <DialogTitle style={{ color: '#00AF39', fontWeight: 'bold' }}><Box display="flex" alignItems="center"><GroupAdd />&nbsp;Função {selectedGrupoAcesso.nome}</Box></DialogTitle>
                          {selectedGrupoAcesso.descricao.includes('\n') ? (
                            <div> {/* Usa div em vez de ul */}
                              {selectedGrupoAcesso.descricao.split('\n').map((item, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                  <CheckCircleIcon style={{ color: '#00a335' }} /> {item}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <CheckCircleIcon style={{ color: '#00a335' }} /> &nbsp; {selectedGrupoAcesso.descricao}
                            </div>
                          )}
                        </>
                      ) : null
                    )}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions style={isMobile ? { display: 'block', padding: "0px 20px 20px 20px"} : { justifyContent: 'flex-start', marginLeft: '253px', paddingBottom: '20px' }}>
                <Button onClick={handleCloseEditDialog} color={isMobile ? "secondary" : "primary"} variant="outlined" fullWidth={isMobile}>
                  Cancelar
                </Button>
                <Button onClick={handleCloseEditDialogSave} color="primary" variant="contained" fullWidth={isMobile} className="btn-confirmar">
                  Salvar
                </Button>
              </DialogActions>
            </Dialog>

            {/* Excluir colaborador dialog */}
            <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog} fullWidth maxWidth="xs">
              <DialogTitle>Deseja inativar o colaborador?</DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseDeleteDialogNo} color="primary" variant="outlined">
                  Não
                </Button>
                <Button onClick={handleCloseDeleteDialogYes} color="primary" variant="contained" style={{ background: 'red' }}>
                  Sim
                </Button>
              </DialogActions>
            </Dialog>


            {colaboradores.length ? (
              <>
                {/* Grid de colaboradores */}
                  { isMobile ? (
                    <>
                      {colaboradores.map((colaborador) => {
                        return (
                          <CardColaboradorMobile
                            colaborador={colaborador}
                            activeTab={activeTab}
                            canEditColaborador={canEditColaborador}
                            canAtivarInativarColaborador={canAtivarInativarColaborador}
                            handleEditClick={handleEditClick}
                            handleDeleteClick={handleDeleteClick}
                            handleActivateClick={handleActivateClick}
                            setColaboradorId={setColaboradorId}
                          />
                        )
                      })}
                    </>
                  ) : (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow style={{ backgroundColor: '#F0F0F0', }}>
                            <TableCell onClick={handleCadastroSortClickAtivo} style={{ cursor: 'pointer' }}>
                              Cadastro {cadastroSortIndicatorAtivo}
                            </TableCell>
                            <TableCell onClick={handleNomeSortClickAtivo} style={{ cursor: 'pointer' }}>
                              Nome {nomeSortIndicatorAtivo}
                            </TableCell>
                            <TableCell>Usuário</TableCell>
                            <TableCell>Grupo de Acesso</TableCell>
                            {(canEditColaborador || canAtivarInativarColaborador) && <TableCell>Ações</TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {colaboradores.map((colaborador) => (
                            <TableRow key={colaborador.id}>
                              <TableCell>{new Date(colaborador.created_at).toLocaleDateString('pt-BR')}</TableCell>
                              <TableCell>{colaborador.nome}</TableCell>
                              <TableCell>{colaborador.usuario}</TableCell>
                              <TableCell>{colaborador.grupo_acesso?.nome}</TableCell>
                              {(canEditColaborador || canAtivarInativarColaborador) && (
                                <TableCell>
                                  {canEditColaborador && (
                                    <Tooltip title="Editar colaborador">
                                      <IconButton aria-label="Editar" onClick={() => { handleEditClick(colaborador); }}>
                                        <EditIcon style={{ color: '#00AF39' }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                  {canAtivarInativarColaborador && (
                                    <Tooltip title="Inativar colaborador">
                                      <IconButton aria-label="Excluir" onClick={() => { handleDeleteClick(); setColaboradorId(String(colaborador.id)); }}>
                                        <Block style={{ color: 'red' }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}

                  {/* Paginação */}
                  <TablePagination
                    component="div"
                    className="cards-paginacao"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    count={totalPagesActive}
                    page={pageAtivos}
                    onPageChange={(event, newPage) => {
                      if (newPage < totalPagesActive) { // Check if newPage is within bounds
                        setPageAtivos(newPage);
                        // Fetch data for the new page (if needed)
                      }
                    }}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPageAtivos(0);
                    }}
                    nextIconButtonProps={{
                      style: {
                        visibility: pageAtivos === totalPagesActive - 1 ? 'hidden' : 'visible',
                      },
                    }}
                    labelRowsPerPage={"Registros por página:"}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count} registros`}
                  />
                </>
              ) : (
                <Empty message="Não há registros" />
              )}
            </>
          )}
          
          {activeTab === 'inativos' && (
            <>
              { isMobile && inputBuscaColaborador }

              {/* Grid de colaboradores */}
              {colaboradoresInativos.length > 0 ? (
                <Box>
                  { isMobile ? (
                    <>
                      {colaboradoresInativos.map((colaboradorInativo) => {
                        return (
                          <CardColaboradorMobile
                            colaborador={colaboradorInativo}
                            activeTab={activeTab}
                            canEditColaborador={canEditColaborador}
                            canAtivarInativarColaborador={canAtivarInativarColaborador}
                            handleEditClick={handleEditClick}
                            handleDeleteClick={handleDeleteClick}
                            handleActivateClick={handleActivateClick}
                            setColaboradorId={setColaboradorId}
                          />
                        )
                      })}
                    </>
                  ) : (
                    <> 
                      {/* Encapsula a Table e a TablePagination */}
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow style={{ backgroundColor: '#F0F0F0', }}>
                              <TableCell onClick={handleCadastroSortClickInativo} style={{ cursor: 'pointer' }}>
                                Cadastro {cadastroSortIndicatorInativo}
                              </TableCell>
                              <TableCell onClick={handleNomeSortClickInativo} style={{ cursor: 'pointer' }}>
                                Nome {nomeSortIndicatorInativo}
                              </TableCell>
                              <TableCell>Usuário</TableCell>
                              <TableCell>Grupo de Acesso</TableCell>
                              {canAtivarInativarColaborador && (
                                <TableCell>Ações</TableCell>
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {colaboradoresInativos.map((colaboradorInativo) => (
                              <TableRow key={colaboradorInativo.id}>
                                <TableCell>{new Date(colaboradorInativo.created_at).toLocaleDateString('pt-BR')}</TableCell>
                                <TableCell>{colaboradorInativo.nome}</TableCell>
                                <TableCell>{colaboradorInativo.usuario}</TableCell>
                                <TableCell>{colaboradorInativo.grupo_acesso?.nome}</TableCell>
                                {canAtivarInativarColaborador && (
                                    <TableCell>
                                        <Tooltip title="Ativar colaborador">
                                            <IconButton aria-label="Ativar" onClick={() => { handleActivateClick(); setColaboradorId(String(colaboradorInativo.id)); }}>
                                                <Check style={{ color: '#00AF39' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                )}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        className="cards-paginacao"
                        component="div"
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                        count={totalPagesInactive}
                        page={pageInativos}
                        onPageChange={(event, newPage) => {
                          if (newPage < totalPagesInactive) { // Check if newPage is within bounds
                            setPageInativos(newPage);
                            // Fetch data for the new page (if needed)
                          }
                        }}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(event) => {
                          setRowsPerPage(parseInt(event.target.value, 10));
                          setPageInativos(0);
                        }}
                        nextIconButtonProps={{
                          style: {
                            visibility: pageInativos === totalPagesInactive - 1 ? 'hidden' : 'visible',
                          },
                        }}
                        labelRowsPerPage={"Registros por página:"}
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count} registros`}
                      />
                    </>
                  )}
                </Box>
              ) : (
                <Empty message="Não há registros" />
              )}

              {/* Ativar colaborador dialog */}
              <Dialog open={activateDialogOpen} onClose={handleCloseActivateDialog} fullWidth maxWidth="xs">
                <DialogTitle>Deseja ativar o colaborador?</DialogTitle>
                <DialogActions>
                  <Button onClick={handleCloseActivateDialogNo} color="primary" variant="outlined">
                    Não
                  </Button>
                  <Button onClick={handleCloseActivateDialogYes} color="primary" variant="contained">
                    Sim
                  </Button>
                </DialogActions>
              </Dialog>
            </>)}
      </Box>
    </Paper >
  );
}

export default Colaboradores;